import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { AngularMaterialCommonModule } from '@app/shared/angular-material/angular-material-common.module';

import { ISearchItem } from '../search.model';
import { SearchService } from '../search.service';

@Component({
  selector: 'app-search-result-card',
  templateUrl: './search-result-card.component.html',
  styleUrl: './search-result-card.component.scss',
  imports: [CommonModule, AngularMaterialCommonModule]
})
export class SearchResultCardComponent {
  @Input() searchResult: ISearchItem;

  constructor(private searchService: SearchService) {}

  handleClick() {
    this.searchService.handleClick(this.searchResult);
  }
}
